/**
 * Social Trends Configuration API Client
 *
 * Functions for managing TrueTrends social media integration settings.
 */

import api from './api';
import {
  SocialTrendsConfig,
  SocialTrendsConfigUpdate,
  CustomTopic,
  CustomTopicCreate,
  TestConnectionResult,
} from '../types/socialConfig';

export const socialConfigApi = {
  /**
   * Get social trends configuration for a project
   */
  getConfig: async (projectId: string): Promise<SocialTrendsConfig> => {
    const response = await api.get<SocialTrendsConfig>(
      `/projects/${projectId}/social-config`
    );
    return response.data;
  },

  /**
   * Update social trends configuration
   */
  updateConfig: async (
    projectId: string,
    config: SocialTrendsConfigUpdate
  ): Promise<SocialTrendsConfig> => {
    const response = await api.patch<SocialTrendsConfig>(
      `/projects/${projectId}/social-config`,
      config
    );
    return response.data;
  },

  /**
   * Add a custom topic
   */
  addCustomTopic: async (
    projectId: string,
    topic: CustomTopicCreate
  ): Promise<CustomTopic> => {
    const response = await api.post<CustomTopic>(
      `/projects/${projectId}/social-config/custom-topics`,
      topic
    );
    return response.data;
  },

  /**
   * Delete a custom topic
   */
  deleteCustomTopic: async (
    projectId: string,
    topicId: string
  ): Promise<void> => {
    await api.delete(
      `/projects/${projectId}/social-config/custom-topics/${topicId}`
    );
  },

  /**
   * Test TrueTrends API connection
   */
  testConnection: async (projectId: string): Promise<TestConnectionResult> => {
    const response = await api.post<TestConnectionResult>(
      `/projects/${projectId}/social-config/test-connection`
    );
    return response.data;
  },
};

export default socialConfigApi;
